import { viewport } from "@faire/slate/lib/mediaQuery";
import React from "react";

export type Viewport = {
  isMobile: boolean;

  /**
   * True if the md: breakpoint applies
   */
  mdMatches: boolean;
  /**
   * True if the lg: breakpoint applies
   */
  lgMatches: boolean;
  /**
   * True if the xl: breakpoint applies
   */
  xlMatches: boolean;
};

export const useViewport = (): Viewport => {
  const isMobile = useMediaQueryMatches(viewport.sm);
  const isMd = useMediaQueryMatches(viewport.md);
  const isLg = useMediaQueryMatches(viewport.lg);
  const isXl = useMediaQueryMatches(viewport.xl);
  const isXxl = useMediaQueryMatches(viewport.xxl);

  const mdMatches = isMd || isLg || isXl || isXxl;
  const lgMatches = isLg || isXl || isXxl;
  const xlMatches = isXl || isXxl;

  return { isMobile, mdMatches, lgMatches, xlMatches };
};

export const useMediaQueryMatches = (
  getMediaQuery: () => MediaQueryList | undefined
): boolean =>
  React.useSyncExternalStore(
    (notify) => {
      const mql = getMediaQuery();
      mql?.addEventListener("change", notify);
      return () => mql?.removeEventListener("change", notify);
    },
    () => getMediaQuery()?.matches ?? false,
    () => false
  );
